import { type InternalAssetMap, type ChainflipChain } from '@chainflip/utils/chainflip';
import { type SwapFee } from './graphql/generated/explorer/graphql';

export const TABLE_POLL_INTERVAL = 10_000;
export const BOOST_FEE_FLIP_BURN_PERCENT = 0.025;

const POOL_FEE = 'Pool fee';
export const NETWORK_FEE = 'Network fee';
export const INGRESS_FEE = 'Deposit fee';
export const EGRESS_FEE = 'Broadcast fee';
export const BROKER_FEE = 'Broker fee';
export const BOOST_FEE = 'Boost fee';

export const feeTypeMap: Record<SwapFee['type'], string> = {
  BROKER: BROKER_FEE,
  NETWORK: NETWORK_FEE,
  BOOST: BOOST_FEE,
  INGRESS: INGRESS_FEE,
  EGRESS: EGRESS_FEE,
  LIQUIDITY: POOL_FEE,
};

export const FIRST_SWAP_DATE = '2023-12-19';

export const chainOrder: Record<ChainflipChain, number> = {
  Bitcoin: 0,
  Ethereum: 1,
  Solana: 2,
  Arbitrum: 3,
  Assethub: 4,
  Polkadot: Infinity,
};

/**
 * we want to order the pools by most important chains first
 * each chain has its assets ordered with the native asset first, then whatever
 * other order for the tokens
 */
export const assetOrder: InternalAssetMap<number> = {
  // Bitcoin
  Btc: 0,
  // Ethereum
  Eth: 1,
  Usdc: 2,
  Usdt: 3,
  Flip: 4,
  // Solana
  Sol: 5,
  SolUsdc: 6,
  // Arbitrum
  ArbEth: 7,
  ArbUsdc: 8,
  // Assethub
  HubDot: 9,
  HubUsdc: 10,
  HubUsdt: 11,
  // Polkadot
  Dot: 12,
};
